import { Tab } from '../../../../../views/active-orders';

export default {
  title: 'Tableau de bord',
  tabs: {
    [Tab.OngoingOrders]: 'À préparer',
    [Tab.FutureOrders]: 'À venir',
    [Tab.CompleteOrders]: 'Terminées',
  },
  buttons: {
    order_history: 'Historique des commandes',
  },
  feedback: {
    future_orders_alert: '⚠️ Ne préparez pas encore – nous vous préviendrons quand commencer.',
  },
};
